import { useFormContext } from 'react-hook-form'
import { FilterFormData } from './FilterReports'
import { DateRangePicker } from '@/view/components/DateRangePicker'
import { DateRange } from 'react-day-picker'
import { format, parse } from 'date-fns'

export default function TransactionDates() {
  const { setValue, watch } = useFormContext<FilterFormData>()

  const transactionStartDate = watch('transactionStartDate')
  const transactionEndDate = watch('transactionEndDate')

  const handleDateChange = (dateRange: DateRange | undefined) => {
    if (dateRange?.from) {
      setValue('transactionStartDate', format(dateRange.from, 'yyyy-MM-dd'))
    } else {
      setValue('transactionStartDate', undefined)
    }

    if (dateRange?.to) {
      setValue('transactionEndDate', format(dateRange.to, 'yyyy-MM-dd'))
    } else {
      setValue('transactionEndDate', undefined)
    }
  }

  
  const parseDate = (dateStr: string | undefined) => {
    if (!dateStr) return undefined
    return parse(dateStr, 'yyyy-MM-dd', new Date())
  }

  const currentDateRange: DateRange | undefined =
    transactionStartDate && transactionEndDate
      ? {
          from: parseDate(transactionStartDate),
          to: parseDate(transactionEndDate),
        }
      : transactionStartDate
        ? { from: parseDate(transactionStartDate), to: undefined }
        : undefined

  return (
    <>
      <h2 className="font-medium text-black04">Data das transações</h2>
      <DateRangePicker date={currentDateRange} onDateChange={handleDateChange} />
    </>
  )
}
